// extracted by mini-css-extract-plugin
export default {"cards":"AF0npdNuZbqJn3KjFXr2","card":"jwK2KWYB6BzJ_KnAqoUa","title":"HK0S0Tnrr7mspZuJkTtq"};